import api from '../api/axios';

// Payment ledger + Square payment requests (see docs/SQUARE_PAYMENTS_DESIGN.md)

const getLedger = (proposalId) => api.get(`/payment/proposal/${proposalId}`);

const recordPayment = (proposalId, data) => api.post(`/payment/proposal/${proposalId}`, data);

const reversePayment = (paymentId, reason) => api.post(`/payment/${paymentId}/reverse`, { reason });
const confirmPayment = (paymentId) => api.post(`/payment/${paymentId}/confirm`);
const updatePayment = (paymentId, data) => api.patch(`/payment/${paymentId}`, data);

const getRequests = (proposalId) => api.get(`/payment/requests/${proposalId}`);

const sendRequest = (proposalId, data) => api.post(`/payment/proposal/${proposalId}/request`, data);

const resendRequest = (requestId, overrides = {}) => api.post(`/payment/request/${requestId}/resend`, overrides);

const cancelRequest = (requestId, reason) => api.post(`/payment/request/${requestId}/cancel`, { reason });

const getReceivables = (params) => api.get('/payment/receivables', { params });

const getReceivablesIssues = () => api.get('/payment/receivables/issues');

const runReconciliation = () => api.post('/payment/reconcile');

const paymentServices = {
  getLedger,
  recordPayment,
  reversePayment,
  confirmPayment,
  updatePayment,
  getRequests,
  sendRequest,
  resendRequest,
  cancelRequest,
  getReceivables,
  getReceivablesIssues,
  runReconciliation,
};

export default paymentServices;
